// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3daabc96","455":"6dc4b633","977":"19472618"}[chunkId] + ".chunk.js";
};